import HttpUtil from './HttpUtil'
import store from './../store/store'

class JqHttpUtil {
  constructor (endpoint) {
    this.endpoint = endpoint
    this.baseUrl = store.state.appSettings.apiurl
    this.headers = HttpUtil.getHeaders()
    this.defaultOptions = {
      url: this.getUrl(),
      headers: HttpUtil.getHeaders()
    }
  }

  getUrl () {
    return this.baseUrl + this.endpoint
  }

  get (data = null, options = {}, resolve = null, reject = null) {
    return this.baseGet(this.endpoint, data, options, resolve, reject)
  }

  baseGet (url, data = null, options = {}, resolve = null, reject = null) {
    let fOptions = {...this.defaultOptions, url: this.baseUrl + url}
    fOptions.method = 'GET'
    fOptions.data = data
    if (resolve !== null) {
      fOptions.success = resolve
    }
    if (reject !== null) {
      fOptions.error = reject
    }

    fOptions = jQuery.extend(true, fOptions, options)
    return jQuery.ajax(fOptions)
  }
}

export default JqHttpUtil



// WEBPACK FOOTER //
// ./src/util/JqHttpUtil.js